import { ChatBotSettingsFormValues } from "@jugl-web/domain-resources/chat-bot";
import {
  MAX_AGENT_NAME_LENGTH,
  MAX_CHAT_NAME_LENGTH,
} from "@jugl-web/domain-resources/chat-bot/consts";
import { TextInput } from "@jugl-web/ui-kit";
import { useFormFieldsValidators, useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { ChatBotAgentAvatarPicker } from "../ChatBotAgentAvatarPicker";
import { ChatBotChatAvatarPicker } from "../../../../components/ChatBotChatAvatarPicker";

export const BrandingSection: FC = () => {
  const { control } = useFormContext<ChatBotSettingsFormValues>();

  const { lengthValidator } = useFormFieldsValidators();

  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <div className="flex items-start gap-4">
          <Controller
            control={control}
            name="chatName"
            rules={{ ...lengthValidator(MAX_CHAT_NAME_LENGTH) }}
            render={({ field: { onChange, ...props } }) => (
              <TextInput
                labelPosition="border-overlap"
                label={t({
                  id: "client-support-page.chat-name",
                  defaultMessage: "Chat Name & Image",
                })}
                placeholder={t({ id: "common.enter", defaultMessage: "Enter" })}
                lengthIndicator={{
                  max: MAX_CHAT_NAME_LENGTH,
                }}
                maxLength={MAX_CHAT_NAME_LENGTH}
                classNames={{
                  wrapperClassName: "w-full",
                  inputClassName: "text-[14px]",
                }}
                onChange={(e) => onChange(e.target.value.trimStart())}
                {...props}
              />
            )}
          />
          <div className="relative top-[9px]">
            <Controller
              control={control}
              name="chatImage"
              render={({ field: { value, onChange } }) => (
                <ChatBotChatAvatarPicker
                  image={value}
                  onImageChange={onChange}
                />
              )}
            />
          </div>
        </div>
        <div className="flex items-start gap-4">
          <Controller
            control={control}
            name="agentName"
            rules={{ ...lengthValidator(MAX_AGENT_NAME_LENGTH) }}
            render={({ field: { onChange, ...props } }) => (
              <TextInput
                labelPosition="border-overlap"
                label={t({
                  id: "client-support-page.agent-name-and-pic",
                  defaultMessage: "Agent Name & pic",
                })}
                placeholder={t({ id: "common.enter", defaultMessage: "Enter" })}
                lengthIndicator={{
                  max: MAX_AGENT_NAME_LENGTH,
                }}
                maxLength={MAX_AGENT_NAME_LENGTH}
                classNames={{
                  wrapperClassName: "w-full",
                  inputClassName: "text-[14px]",
                }}
                onChange={(e) => onChange(e.target.value.trimStart())}
                {...props}
              />
            )}
          />
          <div className="relative top-[9px]">
            <Controller
              control={control}
              name="agentImage"
              render={({ field: { value, onChange } }) => (
                <ChatBotAgentAvatarPicker
                  avatar={value}
                  onAvatarChange={onChange}
                />
              )}
            />
          </div>
        </div>
        <Controller
          control={control}
          name="welcomeMessage"
          render={({ field: { onChange, ...props } }) => (
            <TextInput
              labelPosition="border-overlap"
              label={t({
                id: "client-support-page.welcome-message",
                defaultMessage: "Welcome Message",
              })}
              placeholder={t({
                id: "common.enter",
                defaultMessage: "Enter",
              })}
              onChange={(e) => onChange(e.target.value.trimStart())}
              classNames={{
                inputClassName: "text-[14px]",
              }}
              {...props}
            />
          )}
        />
      </div>
    </div>
  );
};
